import React__default from 'react';
import { useController } from 'react-hook-form';
import { TextArea } from '../../../atoms/TextArea.js';
import { FormItem } from '../FormItem.js';
import { ReadOnlyField, formatReadOnlyValue } from './ReadOnlyFormField.js';

/**
 * TextAreaFormField - A form field component for multi-line text input.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <TextAreaFormField
 *     schemaField="description"
 *     labelText="Description"
 *     placeholder="Enter description"
 *     rows={5}
 *   />
 * </Form>
 * ```
 */
function TextAreaFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, className, id, orientation, linkedField, variant, showFieldToggle, ...textAreaProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    if (isReadOnly) {
        return (React__default.createElement(ReadOnlyField, { label: labelText, value: formatReadOnlyValue(field.value, 'textarea'), description: descriptionText, required: required, className: className }));
    }
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, className: className, id: id, isDisabled: isDisabled, orientation: orientation, linkedField: linkedField, showFieldToggle: showFieldToggle },
        React__default.createElement(TextArea, { ...textAreaProps, variant: variant, isDisabled: isDisabled, isReadOnly: isReadOnly })));
}

export { TextAreaFormField };
//# sourceMappingURL=TextAreaFormField.js.map
